import type { K8s } from '@/entities/kubernetes';
import request from '@/shared/api/request';

export const getKubernetes = (
  uuid: string,
): Promise<{
  kubernetes: K8s;
}> =>
  request({
    url: `/kubernetes/${uuid}/`,
  });
